(function () {
  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeId(value) {
    return String(value || '').trim().replace(/^"+|"+$/g, '');
  }

  function normalizeLinkedItems(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map(function (item) {
        return {
          id: normalizeId(item && item.id),
          title: item && item.title ? item.title : '',
          url: item && item.url ? item.url : ''
        };
      })
      .filter(function (item) { return !!item.id; });
  }

  function initPhotoSection(section) {
    if (!section || section.dataset.photoInited === 'true') return;

    var exploreText = section.dataset.exploreText || 'Explore';
    section.dataset.photoInited = 'true';

    var sectionId = section.id ? section.id.replace('PhotoSection-', '') : '';
    var photosDataEl = document.getElementById('photo-data-photos-' + sectionId);
    if (!photosDataEl) return;

    async function forceDownloadFile(url, fileName) {
      if (!url) return;
      try {
        var response = await fetch(url, { mode: 'cors', credentials: 'omit' });
        if (!response.ok) throw new Error('Download request failed');
        var blob = await response.blob();
        var blobUrl = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = blobUrl;
        tempLink.download = fileName || 'photo.jpg';
        document.body.appendChild(tempLink);
        tempLink.click();
        tempLink.remove();
        setTimeout(function () { window.URL.revokeObjectURL(blobUrl); }, 1000);
      } catch (error) {
        var fallbackLink = document.createElement('a');
        fallbackLink.href = url;
        fallbackLink.download = fileName || 'photo.jpg';
        fallbackLink.rel = 'noopener';
        document.body.appendChild(fallbackLink);
        fallbackLink.click();
        fallbackLink.remove();
      }
    }

    var photos = JSON.parse(photosDataEl.textContent || '[]').map(function (item) {
      return {
        name: item.name || '',
        author: item.author || '',
        thumb: item.thumb || item.photo || '',
        photo: item.thumb || item.photo || '',
        full: item.full || item.download || item.photo || '',
        download: item.download || item.full || item.photo || '',
        camera: normalizeLinkedItems(item.camera),
        lens: normalizeLinkedItems(item.lens)
      };
    });

    var galleryEl = section.querySelector('.photo-gallery');
    var emptyEl = section.querySelector('.photo-empty');

    var paginationWrap = section.querySelector('.photo-pagination');
    if (!paginationWrap && galleryEl) {
      paginationWrap = document.createElement('div');
      paginationWrap.className = 'photo-pagination hidden';
      galleryEl.insertAdjacentElement('afterend', paginationWrap);
    }

    var modal = section.querySelector('.photo-modal');
    var modalMedia = section.querySelector('.photo-modal__media');
    var modalImage = section.querySelector('[id^="PhotoModalImage-"]');
    var modalTitle = section.querySelector('[id^="PhotoModalTitle-"]');
    var modalAuthor = section.querySelector('[id^="PhotoModalAuthor-"]');
    var modalGear = section.querySelector('[id^="PhotoModalGear-"]');
    var modalDownload = section.querySelector('[id^="PhotoModalDownload-"]');
    var modalPrev = section.querySelector('[id^="PhotoModalPrev-"]');
    var modalNext = section.querySelector('[id^="PhotoModalNext-"]');

    var state = {
      filteredPhotos: photos,
      pagedPhotos: [],
      currentIndex: 0,
      currentPage: 1,
      totalPages: 1,
      perPage: getPerPage()
    };

    var isModalAnimating = false;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchCurrentX = 0;
    var touchCurrentY = 0;
    var isSwiping = false;

    function getPerPage() {
      if (window.innerWidth <= 575) return 5;
      if (window.innerWidth <= 1200) return 8;
      return 9;
    }

    function isSideBySideLayout() { return window.innerWidth > 1200; }
    function isSwipeLayout() { return window.innerWidth <= 1200; }

    function updateGalleryLayoutClass() {
      if (!galleryEl) return;
      var isSingleColumn = window.innerWidth <= 575;
      galleryEl.classList.toggle('is-single-column', isSingleColumn);
      galleryEl.classList.toggle('is-multi-column', !isSingleColumn);
    }

    function paginatePhotos() {
      state.perPage = getPerPage();
      state.totalPages = Math.max(1, Math.ceil(state.filteredPhotos.length / state.perPage));
      if (state.currentPage > state.totalPages) state.currentPage = state.totalPages;
      if (state.currentPage < 1) state.currentPage = 1;
      var start = (state.currentPage - 1) * state.perPage;
      state.pagedPhotos = state.filteredPhotos.slice(start, start + state.perPage);
    }

    function renderPagination() {
      if (!paginationWrap) return;
      if (!state.filteredPhotos.length || state.totalPages <= 1) {
        paginationWrap.classList.add('hidden');
        paginationWrap.innerHTML = '';
        return;
      }
      paginationWrap.classList.remove('hidden');

      var pageNumbersHtml = '';
      for (var i = 1; i <= state.totalPages; i++) {
        pageNumbersHtml += '<button type="button" class="photo-pagination__page' + (i === state.currentPage ? ' is-active' : '') + '" data-page="' + i + '">' + i + '</button>';
      }

      paginationWrap.innerHTML =
        '<div class="photo-pagination__inner">' +
          '<button type="button" class="photo-pagination__prev' + (state.currentPage === 1 ? ' is-disabled' : '') + '" data-page-action="prev"' + (state.currentPage === 1 ? ' disabled' : '') + '>' +
            '<span class="photo-pagination__arrow">‹</span><span class="photo-pagination__text">Previous</span>' +
          '</button>' +
          '<div class="photo-pagination__pages">' + pageNumbersHtml + '</div>' +
          '<button type="button" class="photo-pagination__next' + (state.currentPage === state.totalPages ? ' is-disabled' : '') + '" data-page-action="next"' + (state.currentPage === state.totalPages ? ' disabled' : '') + '>' +
            '<span class="photo-pagination__text">Next</span><span class="photo-pagination__arrow">›</span>' +
          '</button>' +
        '</div>';

      paginationWrap.querySelector('[data-page-action="prev"]')?.addEventListener('click', function () {
        if (state.currentPage <= 1) return;
        state.currentPage -= 1;
        renderGalleryPage(true);
      });

      paginationWrap.querySelector('[data-page-action="next"]')?.addEventListener('click', function () {
        if (state.currentPage >= state.totalPages) return;
        state.currentPage += 1;
        renderGalleryPage(true);
      });

      paginationWrap.querySelectorAll('[data-page]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetPage = Number(btn.dataset.page || 1);
          if (targetPage === state.currentPage) return;
          state.currentPage = targetPage;
          renderGalleryPage(true);
        });
      });
    }

    function bindCardClickEvents() {
      if (!galleryEl) return;
      galleryEl.querySelectorAll('.photo-card').forEach(function (card) {
        card.addEventListener('click', function () {
          state.currentIndex = Number(card.dataset.photoIndex || 0);
          openModal();
        });
      });
    }

    function renderGalleryPage(keepViewportTop) {
      if (!galleryEl) return;
      updateGalleryLayoutClass();
      paginatePhotos();

      if (!state.filteredPhotos.length) {
        galleryEl.innerHTML = '';
        if (paginationWrap) paginationWrap.classList.add('hidden');
        if (emptyEl) emptyEl.classList.remove('hidden');
        return;
      }

      if (emptyEl) emptyEl.classList.add('hidden');

      var start = (state.currentPage - 1) * state.perPage;
      galleryEl.innerHTML = state.pagedPhotos.map(function (item, index) {
        var globalIndex = start + index;
        return (
          '<article class="photo-card" data-photo-index="' + globalIndex + '">' +
            '<div class="photo-card__image">' +
              '<img src="' + (item.thumb || item.photo) + '" alt="' + escapeHtml(item.name) + '" loading="lazy">' +
            '</div>' +
            '<div class="photo-card__meta">' +
              '<p class="photo-card__author">© ' + escapeHtml(item.author) + '</p>' +
            '</div>' +
          '</article>'
        );
      }).join('');

      bindCardClickEvents();
      renderPagination();

      if (keepViewportTop) {
        requestAnimationFrame(function () {
          galleryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    function renderModalLinkedRows(items) {
      if (!Array.isArray(items) || !items.length) return '';
      return items.map(function (item) {
        if (item.url) {
          return '<div class="photo-modal__gear-row"><a class="photo-modal__gear-link" href="' + item.url + '">' + escapeHtml(exploreText) + ' ' + escapeHtml(item.title) + ' ></a></div>';
        }
        return '<div class="photo-modal__gear-row">' + escapeHtml(item.title) + '</div>';
      }).join('');
    }

    function syncModalNavVisibility() {
      var many = state.filteredPhotos.length > 1;
      var showNav = many && isSideBySideLayout();
      if (modalPrev) modalPrev.style.display = showNav ? 'block' : 'none';
      if (modalNext) modalNext.style.display = showNav ? 'block' : 'none';
    }

    function setModalImageContent() {
      var item = state.filteredPhotos[state.currentIndex];
      if (!item || !modal) return;

      if (modalImage) { modalImage.src = item.full || item.photo; modalImage.alt = item.name || ''; }
      if (modalAuthor) modalAuthor.textContent = item.author ? '© ' + item.author : '';

      if (modalGear) {
        modalGear.innerHTML = renderModalLinkedRows(item.camera) + renderModalLinkedRows(item.lens);
      }

      if (modalDownload) {
        var downloadUrl = item.download || item.full || item.photo || '';
        var fileName = (item.name || 'photo').replace(/[\\/:*?"<>|]+/g, '-').replace(/\s+/g, ' ').trim() || 'photo';
        modalDownload.href = downloadUrl;
        modalDownload.setAttribute('download', fileName + '.jpg');
        modalDownload.setAttribute('data-download-url', downloadUrl);
        modalDownload.setAttribute('data-download-name', fileName + '.jpg');
      }

      syncModalNavVisibility();
    }

    function clearAnimationClasses() {
      if (!modalMedia) return;
      modalMedia.classList.remove('is-animating', 'is-next-out', 'is-next-in', 'is-prev-out', 'is-prev-in');
    }

    function animateModalChange(direction) {
      if (!modalMedia || !modalImage || isModalAnimating) { setModalImageContent(); return; }
      isModalAnimating = true;
      var outClass = direction === 'next' ? 'is-next-out' : 'is-prev-out';
      var inClass = direction === 'next' ? 'is-next-in' : 'is-prev-in';
      clearAnimationClasses();
      modalMedia.classList.add('is-animating');
      requestAnimationFrame(function () {
        modalMedia.classList.add(outClass);
        setTimeout(function () {
          modalMedia.classList.remove(outClass);
          setModalImageContent();
          modalMedia.classList.add(inClass);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              modalMedia.classList.remove(inClass);
              setTimeout(function () { clearAnimationClasses(); isModalAnimating = false; }, 350);
            });
          });
        }, 350);
      });
    }

    function openModal() {
      if (!modal) return;
      clearAnimationClasses();
      isModalAnimating = false;
      setModalImageContent();
      modal.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');
      syncModalNavVisibility();
    }

    function closeModal() {
      if (!modal) return;
      clearAnimationClasses();
      isModalAnimating = false;
      modal.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    }

    function prevPhoto() {
      if (!state.filteredPhotos.length || isModalAnimating) return;
      state.currentIndex = (state.currentIndex - 1 + state.filteredPhotos.length) % state.filteredPhotos.length;
      animateModalChange('prev');
    }

    function nextPhoto() {
      if (!state.filteredPhotos.length || isModalAnimating) return;
      state.currentIndex = (state.currentIndex + 1) % state.filteredPhotos.length;
      animateModalChange('next');
    }

    section.querySelectorAll('[data-photo-close]').forEach(function (el) {
      el.addEventListener('click', function (evt) { evt.preventDefault(); closeModal(); });
    });

    if (modalPrev) modalPrev.addEventListener('click', function (evt) { evt.preventDefault(); prevPhoto(); });
    if (modalNext) modalNext.addEventListener('click', function (evt) { evt.preventDefault(); nextPhoto(); });

    if (modalDownload) {
      modalDownload.addEventListener('click', function (evt) {
        evt.preventDefault();
        forceDownloadFile(
          modalDownload.getAttribute('data-download-url') || modalDownload.href || '',
          modalDownload.getAttribute('data-download-name') || 'photo.jpg'
        );
      });
    }

    document.addEventListener('keydown', function (evt) {
      if (!modal || modal.classList.contains('hidden')) return;
      if (evt.key === 'Escape') closeModal();
      if (evt.key === 'ArrowLeft') prevPhoto();
      if (evt.key === 'ArrowRight') nextPhoto();
    });

    if (modalMedia) {
      modalMedia.addEventListener('touchstart', function (evt) {
        if (!isSwipeLayout() || !evt.touches?.length) return;
        touchStartX = touchCurrentX = evt.touches[0].clientX;
        touchStartY = touchCurrentY = evt.touches[0].clientY;
        isSwiping = true;
      }, { passive: true });

      modalMedia.addEventListener('touchmove', function (evt) {
        if (!isSwiping || !isSwipeLayout() || !evt.touches?.length) return;
        touchCurrentX = evt.touches[0].clientX;
        touchCurrentY = evt.touches[0].clientY;
      }, { passive: true });

      modalMedia.addEventListener('touchend', function () {
        if (!isSwiping) return;
        isSwiping = false;
        if (!isSwipeLayout() || isModalAnimating) return;
        var diffX = touchCurrentX - touchStartX;
        var diffY = touchCurrentY - touchStartY;
        if (Math.abs(diffX) < 50 || Math.abs(diffX) <= Math.abs(diffY)) return;
        diffX < 0 ? nextPhoto() : prevPhoto();
      }, { passive: true });

      modalMedia.addEventListener('touchcancel', function () { isSwiping = false; }, { passive: true });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var oldPerPage = state.perPage;
        var newPerPage = getPerPage();
        updateGalleryLayoutClass();
        if (oldPerPage !== newPerPage) {
          state.perPage = newPerPage;
          state.currentPage = 1;
        }
        renderGalleryPage(false);
        if (modal && !modal.classList.contains('hidden')) syncModalNavVisibility();
      }, 120);
    });

    renderGalleryPage(false);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.photo-page').forEach(initPhotoSection);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target;
    if (!container) return;
    var section = container.querySelector('.photo-page') || container.closest('.photo-page');
    if (section) initPhotoSection(section);
  });
})();